/**
 * @param {Object} props
 * @param {string | undefined} [props.className]
 * @returns {React.ReactElement} The rendered component
 */
const SmartphoneIcon = ({ className }) => (
  <svg
    className={className}
    width="25px"
    height="23px"
    viewBox="0 0 400 400"
    version="1.2"
    baseProfile="tiny"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g>
      <path
        fill="currentColor"
        d="M224.4,31.2h-48.8c-7,0-12.8,5.7-12.8,12.8s5.7,12.8,12.8,12.8h48.8c7,0,12.8-5.7,12.8-12.8
		S231.5,31.2,224.4,31.2z"
      />

      <ellipse
        transform="matrix(0.9732 -0.2298 0.2298 0.9732 -73.9374 55.1823)"
        fill="currentColor"
        cx="200"
        cy="345.1"
        rx="20.9"
        ry="20.9"
      />
      <path
        fill="currentColor"
        d="M297.7,0H102.3C81.8,0,65.1,16.7,65.1,37.2v325.6c0,20.5,16.7,37.2,37.2,37.2h195.3
		c20.5,0,37.2-16.7,37.2-37.2V37.2C334.9,16.7,318.2,0,297.7,0z M90.7,37.2c0-6.4,5.2-11.6,11.6-11.6h0h195.3
		c6.4,0,11.6,5.2,11.6,11.6v26.6H90.7V37.2z M309.3,362.8c0,6.4-5.2,11.6-11.6,11.6H102.3c-6.4,0-11.6-5.2-11.6-11.6v-45.5h218.6
		V362.8z M309.3,291.6H90.7V89.3h218.6h0V291.6z"
      />
    </g>
  </svg>
);

export default SmartphoneIcon;
